import { SocTwoFrameworkId } from '../../constants';

export function isSOC2Like(resource: { framework_id?: string; framework_icon_id?: string }): boolean {
  return resource.framework_id === SocTwoFrameworkId || resource.framework_icon_id === SocTwoFrameworkId;
}
